import { reactive } from 'vue'
import actions from '@/store/mobile/actions'
import state from '@/store/mobile/state'
import getters from '@/store/mobile/getters'

export const mobileModule = {
    state: reactive(state),
    actions,
    getters,
}
